import "./modules/global.js";

document.addEventListener("DOMContentLoaded", () => {
	const wrap = document.querySelector(".single-guides-template");
	if (!wrap) return;

	const progressBar = wrap.querySelector(".guide-progress-fill");
	const progressLabel = wrap.querySelector(".guide-progress-label");
	const stepNumber = wrap.querySelector(".step-number");
	const stepTitle = wrap.querySelector(".step-title");
	const stepContent = wrap.querySelector(".step-content");
	const continueBtn = wrap.querySelector(".giid-guide-continue");
	const nextStepNumber = wrap.querySelector(".next-step-number");
	const guideContent = wrap.querySelector(".guide-content");
	const backToStepButton = wrap.querySelector(".back-to-step-button");

	if (
		typeof giidGuide === "undefined" ||
		!giidGuide.steps ||
		!giidGuide.steps.length
	)
		return;

	const { ajaxUrl, nonce, guideId, totalSteps, steps, completedSteps } =
		giidGuide;

	function updateStepUI(index) {
		if (index < 0 || index >= steps.length) return;
		const step = steps[index];
		if (stepNumber) stepNumber.textContent = index + 1;
		if (stepTitle) stepTitle.textContent = step.title || "Step " + (index + 1);
		if (stepContent) stepContent.innerHTML = step.content || "";
		if (nextStepNumber) nextStepNumber.textContent = index + 2;
		if (guideContent) guideContent.setAttribute("data-current-step", index);
		if (continueBtn) {
			continueBtn.setAttribute("data-step-index", index);
			if (index >= totalSteps - 1) {
				continueBtn.style.display = "none";
				const doneMsg = wrap.querySelector(".guide-complete-message");
				if (doneMsg) doneMsg.style.display = "block";
			} else {
				continueBtn.style.display = "";
				const doneMsg = wrap.querySelector(".guide-complete-message");
				if (doneMsg) doneMsg.style.display = "none";
			}
		}
		if (backToStepButton) {
			if (index === 0) {
				backToStepButton.style.display = "none";
			} else {
				backToStepButton.style.display = "";
				backToStepButton.setAttribute("data-step-index", index - 1);
				const prevStepSpan = backToStepButton.querySelector(
					".previous-step-number",
				);
				if (prevStepSpan) prevStepSpan.textContent = index;
			}
		}
	}

	function updateProgress(percent) {
		if (progressBar) progressBar.style.width = percent + "%";
		if (progressLabel) progressLabel.textContent = percent + "% complete";
		const bar = wrap.querySelector(".guide-progress-bar");
		if (bar) bar.setAttribute("aria-valuenow", percent);
	}

	if (backToStepButton) {
		backToStepButton.addEventListener("click", (e) => {
			e.preventDefault();
			const stepIndex = parseInt(
				backToStepButton.getAttribute("data-step-index"),
				10,
			);
			if (isNaN(stepIndex) || stepIndex < 0 || stepIndex >= totalSteps) return;
			updateStepUI(stepIndex);
		});
	}

	if (continueBtn) {
		continueBtn.addEventListener("click", function () {
			const stepIndex = parseInt(this.getAttribute("data-step-index"), 10);
			if (isNaN(stepIndex) || stepIndex < 0 || stepIndex >= totalSteps) return;

			const formData = new FormData();
			formData.append("action", "giid_guide_step_complete");
			formData.append("nonce", nonce);
			formData.append("guide_id", guideId);
			formData.append("step_index", stepIndex);

			continueBtn.disabled = true;

			fetch(ajaxUrl, {
				method: "POST",
				body: formData,
				credentials: "same-origin",
			})
				.then((res) => res.json())
				.then((data) => {
					if (data.success && data.data) {
						updateProgress(data.data.percent);
						const nextIndex = stepIndex + 1;
						if (nextIndex < totalSteps) {
							updateStepUI(nextIndex);
						} else {
							updateStepUI(totalSteps - 1);
							continueBtn.style.display = "none";
							let doneMsg = wrap.querySelector(".guide-complete-message");
							if (!doneMsg) {
								doneMsg = document.createElement("p");
								doneMsg.className = "guide-complete-message";
								doneMsg.textContent = "You have completed this guide.";
								guideContent && guideContent.appendChild(doneMsg);
							}
							doneMsg.style.display = "block";
						}
					}
				})
				.catch(() => {})
				.finally(() => {
					continueBtn.disabled = false;
				});
		});
	}
});
